<template>
  <div>
    <hhwhclb />
  </div>
</template>

<script>
// 获取接口地址
import Hhwhclb from '@/components/hhwhcRequest/hhwhclb.vue'

export default {
  name: 'Hhwhc',
  components: {

    Hhwhclb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
